import {
  CURRENT_VERSION,
  LAST_VERSION_KEY,
  TOUR_STORAGE_KEY,
} from "../components/onboarding/tour-content";
import type { OnboardingSurface } from "./onboarding-v2";

export const ONBOARDED_KEY = "fintheon:onboarded-beta-v2";
export const ONBOARDING_RESTART_EVENT = "fintheon:onboarding-restart";

const TOUR_PENDING_KEY = "fintheon:tour-pending";
const ONBOARDING_RESTART_KEY = "fintheon:onboarding-restart-pending";

export function hasOnboardedHint(surface: string): boolean {
  try {
    return (
      localStorage.getItem(`${ONBOARDED_KEY}:${surface}`) === "1" ||
      localStorage.getItem(ONBOARDED_KEY) === "1"
    );
  } catch {
    return false;
  }
}

export function hasOnboardingRestartRequest(surface: string): boolean {
  try {
    return (
      localStorage.getItem(`${ONBOARDING_RESTART_KEY}:${surface}`) === "1" ||
      localStorage.getItem(ONBOARDING_RESTART_KEY) === "1"
    );
  } catch {
    return false;
  }
}

export function markOnboardedHint(surface: string): void {
  try {
    localStorage.setItem(`${ONBOARDED_KEY}:${surface}`, "1");
  } catch {
    /* ignore */
  }
}

export function markOnboardingComplete(surface: string): void {
  try {
    markOnboardedHint(surface);
    localStorage.removeItem(`${ONBOARDING_RESTART_KEY}:${surface}`);
    localStorage.removeItem(ONBOARDING_RESTART_KEY);
    localStorage.setItem(`${TOUR_PENDING_KEY}:${surface}`, "1");
  } catch {
    /* ignore */
  }
}

export function requestOnboardingRestart(surface: OnboardingSurface): void {
  try {
    localStorage.removeItem(`${ONBOARDED_KEY}:${surface}`);
    localStorage.removeItem(ONBOARDED_KEY);
    localStorage.removeItem(`${TOUR_PENDING_KEY}:${surface}`);
    localStorage.removeItem(TOUR_STORAGE_KEY);
    localStorage.removeItem(LAST_VERSION_KEY);
    localStorage.setItem(`${ONBOARDING_RESTART_KEY}:${surface}`, "1");
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(ONBOARDING_RESTART_EVENT, { detail: { surface } }),
    );
  }
}

export function hasPendingOnboardingTour(surface: string): boolean {
  try {
    return localStorage.getItem(`${TOUR_PENDING_KEY}:${surface}`) === "1";
  } catch {
    return false;
  }
}

export function markOnboardingTourComplete(surface: string): void {
  try {
    localStorage.removeItem(`${TOUR_PENDING_KEY}:${surface}`);
    localStorage.setItem(TOUR_STORAGE_KEY, "true");
    localStorage.setItem(LAST_VERSION_KEY, CURRENT_VERSION);
  } catch {
    /* ignore */
  }
}
